<template>
  <DashboardTableWrapper
    title="Rupture de stock"
    :loading="loading"
    :error="error"
    :has-data="!!data && data.length > 0"
    @retry="refresh"
  >
    <table class="w-full text-sm">
      <thead>
        <tr class="bg-gray-50 text-left">
          <th class="px-4 py-3 font-semibold text-gray-600">Produit</th>
          <th class="px-4 py-3 font-semibold text-gray-600">SKU</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Categorie</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Prix HT</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Statut</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" :key="item.id" class="border-t border-gray-100 hover:bg-gray-50">
          <td class="px-4 py-3 font-medium text-gray-800">{{ item.name }}</td>
          <td class="px-4 py-3 text-gray-500">{{ item.sku }}</td>
          <td class="px-4 py-3 text-gray-500">{{ item.category || '—' }}</td>
          <td class="px-4 py-3 font-semibold">{{ formatCurrency(item.price_ht) }}</td>
          <td class="px-4 py-3">
            <span class="inline-flex items-center px-2 py-1 text-xs font-bold rounded-full bg-red-100 text-red-700">
              Rupture
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </DashboardTableWrapper>
</template>

<script setup>
import { useDashboard } from '@/composables/useDashboard'
import { formatCurrency } from './helpers'
import DashboardTableWrapper from './DashboardTableWrapper.vue'

const { data, loading, error, refresh } = useDashboard('/dashboard/tables/out-of-stock')
</script>
